import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import {
  brandOverride,
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { P00062 } from '../../../../P00062';
import { getTemperature } from '../../../../../../helper/temperature';
import { transformHourToDayHour } from '../../../../../../helper/horloge';
import {
  PoolAdditionalData,
  PoolApi,
} from '../../../../../../../../apis/pool.api';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';
import { HttpClient } from '@angular/common/http';
import { LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';
import { UserContextService } from '../../../../../../../user-context.service';

export interface PolyResponse {
  error: string;
  lang: string;
  pseudo: string;
  serialNumber: string;
  uri: string;
}

@Component({
  selector: 'app-p00062-chauffage-statut',
  templateUrl: './p00062-chauffage-statut.component.html',
  styleUrls: ['./p00062-chauffage-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
    TranslatePipe,
    CollapseComponent,
  ],
})
export class P00062ChauffageStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);
  private poolApi: PoolApi = inject(PoolApi);
  private http: HttpClient = inject(HttpClient);
  private loadingController: LoadingController = inject(LoadingController);
  private userContextService: UserContextService = inject(UserContextService);
  private router: Router = inject(Router);

  public actionStack: DeviceActionStackService | null = null;
  public additionalData: PoolAdditionalData | undefined | null = undefined;

  constructor() {}

  async ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    try {
      const poolId = this.edroNetworkManager.getPoolContext()?.pool?.id;
      if (poolId) {
        this.additionalData = await this.poolApi.getPoolAdditionalData(poolId);
      }
    } catch (error) {
      this.additionalData = {};
    }
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  get hasAlarm(): boolean {
    return this.getValue('ppSAlarme') === 1;
  }

  get produitP00062(): number {
    const master = getPoolMasterClass(
      this.edroNetworkManager.getPoolContext()!.pool!,
    );
    return (
      master?.hasProduct(
        this.edroNetworkManager.getPoolContext()!.pool!,
        new P00062(),
      ) ?? 0
    );
  }

  get codeDefautHasWarning(): boolean {
    return this.getValue('ppSEtatSysteme') === 0;
  }

  get hasCodeDefaut(): boolean {
    return (
      this.getValue('ppSDefaut1') > 0 ||
      this.getValue('ppSDefaut2') > 0 ||
      this.getValue('ppSDefaut3') > 0 ||
      this.getValue('ppSDefaut4') > 0
    );
  }

  displayGoodDefault(): string {
    const default1 = this.getValue('ppSDefaut1');
    const default2 = this.getValue('ppSDefaut2');
    const default3 = this.getValue('ppSDefaut3');
    const default4 = this.getValue('ppSDefaut4');

    let res: { priority: number; text: string }[] = [];

    if (default1 > 0) {
      res.push({ priority: 255, text: '---' });
    }
    if (((default2 >> 0) & 1) == 1) {
      res.push({ priority: 3, text: 'AL03' });
    }
    if (((default2 >> 1) & 1) == 1) {
      res.push({ priority: 4, text: 'AL04' });
    }
    if (((default2 >> 2) & 1) == 1) {
      res.push({ priority: 5, text: 'AL05' });
    }
    if (((default2 >> 3) & 1) == 1) {
      res.push({ priority: 6, text: 'AL06' });
    }
    if (((default2 >> 4) & 1) == 1) {
      res.push({ priority: 26, text: 'AL14' });
    }
    if (((default2 >> 5) & 1) == 1) {
      res.push({ priority: 1, text: 'AL01' });
    }
    if (((default2 >> 6) & 1) == 1) {
      res.push({ priority: 2, text: 'AL02' });
    }
    if (((default2 >> 7) & 1) == 1) {
      res.push({ priority: 17, text: 'AL15' });
    }
    if (((default2 >> 8) & 1) == 1) {
      res.push({ priority: 12, text: 'AL16' });
    }
    if (((default2 >> 9) & 1) == 1) {
      res.push({ priority: 18, text: 'AL17' });
    }
    if (((default2 >> 10) & 1) == 1) {
      res.push({ priority: 15, text: 'AL10' });
    }
    if (((default2 >> 11) & 1) == 1) {
      res.push({ priority: 10, text: 'AL11' });
    }
    if (((default2 >> 12) & 1) == 1) {
      res.push({ priority: 16, text: 'AL12' });
    }
    if (((default2 >> 13) & 1) == 1) {
      res.push({ priority: 11, text: 'AL13' });
    }
    if (((default2 >> 14) & 1) == 1) {
      res.push({ priority: 27, text: 'FLO' });
    }
    if (((default2 >> 15) & 1) == 1) {
      res.push({ priority: 255, text: '---' });
    }
    if (((default3 >> 0) & 1) == 1) {
      res.push({ priority: 19, text: 'AL18' });
    }
    if (((default3 >> 1) & 1) == 1) {
      res.push({ priority: 20, text: 'AL19' });
    }
    if (((default3 >> 2) & 1) == 1) {
      res.push({ priority: 22, text: 'AL21' });
    }
    if (((default3 >> 3) & 1) == 1) {
      res.push({ priority: 21, text: 'AL20' });
    }
    if (((default3 >> 4) & 1) == 1) {
      res.push({ priority: 23, text: 'AL22' });
    }
    if (((default3 >> 5) & 1) == 1) {
      res.push({ priority: 13, text: 'AL23' });
    }
    if (((default3 >> 6) & 1) == 1) {
      res.push({ priority: 24, text: 'AL24' });
    }
    if (((default3 >> 7) & 1) == 1) {
      res.push({ priority: 25, text: 'AL25' });
    }
    if (((default3 >> 8) & 1) == 1) {
      res.push({ priority: 9, text: 'AL09' });
    }
    if (((default3 >> 9) & 1) == 1) {
      res.push({ priority: 255, text: '---' });
    }
    if (((default3 >> 10) & 1) == 1) {
      res.push({ priority: 14, text: 'EA07' });
    }
    if (default3 >> 11 > 0) {
      res.push({ priority: 255, text: '---' });
    }
    if (((default4 >> 0) & 1) == 1) {
      res.push({ priority: 7, text: 'AL07' });
    }
    if (((default4 >> 1) & 1) == 1) {
      res.push({ priority: 8, text: 'AL08' });
    }
    if (default4 >> 2 > 0) {
      res.push({ priority: 255, text: '---' });
    }

    if (res.length > 0) {
      const resSorted = res.sort((a, b) => a.priority - b.priority);
      return resSorted[0].text;
    }

    return '---';
  }

  getBypassPacValue(): string {
    const bypassValue = this.getValue('ppSBypassPac');
    if (bypassValue === 0) {
      return '--';
    }
    return this.translateService.instant(
      'P00062.status.code.default.bypass.value.' + bypassValue,
    );
  }

  getTemperatureFctHorloge(): string {
    if (this.getValue('ppSCommandeHorloge') === 0) {
      return '-';
    }
    return getTemperature(
      this.getValue('ppSTemperatureConsigneHorloge') / 10,
      1,
    );
  }

  getEtatVoletValue(): string {
    return this.getValue('ppSEtatVolet') === 0
      ? this.translateService.instant(
          'P00062.status.fonctionnement.etatvolet.ouvert',
        )
      : this.translateService.instant(
          'P00062.status.fonctionnement.etatvolet.ferme',
        );
  }

  async onPolySupportClick(): Promise<void> {
    if (!this.additionalData?.ppIdentificationPACPoly) {
      return;
    }

    const loading = await this.loadingController.create({
      message: this.translateService.instant('loading'),
    });
    await loading.present();

    try {
      const response = await this.getPolySupportURL(
        this.additionalData.ppIdentificationPACPoly,
        this.translateService.getCurrentLang(),
        this.userContextService.getCurrentUser()?.name || '',
      );

      if (response?.uri) {
        // Ouvrir dans un nouvel onglet
        window.open(response.uri, '_blank');
      }
    } catch (error) {
      console.error("Erreur lors de l'accès au support Polytropic:", error);
    } finally {
      await loading.dismiss();
    }
  }

  private getPolySupportURL(
    polytropicSn: string,
    lang: string,
    pseudo: string,
  ) {
    const POLYBASE_URI =
      'https://fnacwaconnectpv16cqee-polytropic-supporturl.functions.fnc.fr-par.scw.cloud';

    const headers = {
      'X-Auth-Token':
        'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbl9jbGFpbSI6W3sibmFtZXNwYWNlX2lkIjoiIiwiYXBwbGljYXRpb25faWQiOiJiZDVlOWZjOC1lYWMyLTQwNzgtODI1MC0yMmEwNzE3MTZiOWUifV0sInZlcnNpb24iOjIsImF1ZCI6ImZ1bmN0aW9ucyIsImp0aSI6IjRhZGJjODNjLTlkZGQtNGFiMy1iM2EwLTYwNzFiMTgxMmExNSIsImlhdCI6MTc2MjkzMTIwNiwiaXNzIjoiU0NBTEVXQVkiLCJuYmYiOjE3NjI5MzEyMDYsInN1YiI6InRva2VuIn0.mBKIid0I4qbaMyg6V1xz13kg1iDPs_1a9k0S2fFv76qskCi6eutwWlAmKl5wAzj_nJVoP23DkQbGtaMr1c4Nf28WvpdurahZa6ytqUzfsUFwEeHGlCsZWZz1Y3gTEF8nIJFOiXiwo5z8uT18V7tuLh6akKuJ3UlknrGwwiO4OL_9Ky83yRuLO3tguZ9MiDIgkdaTD7lzLcEV1sm_DOYf0tWQ9Qc3JbhMlY2TqQxU1OxNjpclEipgyCb_OEPI-6CqlE-hzx4hJnPx-EhrDkUyMYgO6HtlSkOaQ_boItF4tA54q_uJItjG_EVDIgoUdgS8pvh_v7XOpBjRtRwjVUeeBaHvvZrueI3nbZU_GlYhphWZZQMbp1lbSx3vZq8sf8RFeOfOqODzkwke8mEZvrIlboF0mecFV7i5mmI5EJiCaf3Xc2fkFr29Yo36EZ29Bh1HlzcJqjEOjmdRtLACK8PsyfGRpva6_GYIJ0N5j1m99u_hkhcDrr6FGwlULuvEbMHgV-gr43tBmhK6lsEuBmS57jhMing1zq_Xmcce7bkAfHNoJmuE0KllOmFHMnQyu3J4PJtKQkIwPkw52ithXe0pBkzEw3qlGjXVenJkljtOImtR46YRcPIbHBt_c8IUDzoFEgZDu27L3LiD0kU9E79D2_CRsZqSwl39Uo7SsKORmz4',
    };

    const body = {
      sn: polytropicSn,
      lang: lang,
      pseudo: pseudo,
    };

    return this.http
      .post<PolyResponse>(POLYBASE_URI, body, { headers })
      .toPromise();
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly getTemperature = getTemperature;
  protected readonly brandOverride = brandOverride;
}
